// Per-route metadata, keyed by the `page` value each view passes to <Meta />.

const SEO = [
	{
		page: "home",
		title: "Anjanava Biswas · Applied AI Architecture",
		description:
			"Anjanava Biswas is a solutions architect working in applied AI: agentic systems, generative AI in production, and intelligent document processing. Author of Building Agentic AI Systems.",
		keywords: [
			"Anjanava Biswas",
			"Anjan Biswas",
			"applied AI",
			"agentic systems",
			"solutions architect",
		],
	},
	{
		page: "practice",
		title: "Practice · Anjanava Biswas",
		description:
			"Capability, trajectory and open source: agentic systems, generative AI in production, document intelligence, trust and safety, computer vision and NLP, enterprise architecture.",
		keywords: [
			"Anjanava Biswas",
			"agentic systems",
			"document intelligence",
			"LLM guardrails",
			"enterprise architecture",
		],
	},
	{
		page: "publications",
		title: "Publications · Anjanava Biswas",
		description:
			"Books and research papers on document intelligence, model reliability, agent meta-reasoning, and the guardrails around generative systems.",
		keywords: [
			"Anjanava Biswas",
			"AI research",
			"arXiv",
			"IEEE",
			"Building Agentic AI Systems",
		],
	},
	{
		page: "recognition",
		title: "Recognition · Anjanava Biswas",
		description:
			"IEEE Senior Member, IET and BCS Fellow, OWASP LLM Top 10 contributor, SIA AI Advisory Board, Gold Stevie Award winner.",
		keywords: [
			"Anjanava Biswas",
			"IEEE Senior Member",
			"IET Fellow",
			"BCS Fellow",
			"Gold Stevie Award",
		],
	},
	{
		page: "about",
		title: "About · Anjanava Biswas",
		description:
			"Nineteen years of shipping systems that had to work: ERP and retail, platform architecture at Petco, five years at AWS, and applied AI today.",
		keywords: ["Anjanava Biswas", "about", "AI architect", "San Diego"],
	},
	{
		page: "404",
		title: "Not found · Anjanava Biswas",
		description: "That page is not here.",
		keywords: ["Anjanava Biswas"],
	},
];

export default SEO;
